export default __webpack_public_path__ + "static/media/Image-5.ff9ae4b5.jpg";